<div class="page-header" [ngClass]="headerClass">
  <div class="page-header-main">
    <div class="flex min-w-0 items-start gap-4">
      @if (icon) {
        <div
          class="mt-1 flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border border-periwinkle-border bg-periwinkle-soft text-periwinkle"
          aria-hidden="true"
        >
          <span class="material-icons text-[22px]">{{ icon }}</span>
        </div>
      }

      <div class="min-w-0">
        <h1 class="page-title">{{ title }}</h1>
        @if (description) {
          <p class="page-description">{{ description }}</p>
        }
      </div>
    </div>

    <ng-content select="[page-meta]"></ng-content>
  </div>

  <ng-content select="[page-actions]"></ng-content>
</div>
